import React, { Component, Suspense } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { Loading } from './components/Loading';
import './custom.css';
import i18n from './i18n';

const ConsultaViaje = React.lazy(() => import('./components/ConsultaViaje'));
const ConsultaDocumento = React.lazy(() => import('./components/ConsultaDocumento'));

export default class App extends Component {
  static displayName = App.name;

    componentDidMount() {
        i18n.changeLanguage('base');
    }

    render () {
        return (
            <Layout>
                <Suspense fallback={<Loading />}>
                    <Route exact path='/' component={Home} />
                    <Route path='/viaje' render={(props) => <ConsultaViaje {...props} />} />
                    <Route path='/documento' render={(props) => <ConsultaDocumento {...props} />} />
                </Suspense>
            </Layout>
        );
    }
}
